import { UnknownAction } from "@reduxjs/toolkit";
import {
  RECORDING_REFERRAL_INFO_FAILED,
  RECORDING_REFERRAL_INFO_SUCCEEDED,
  RECORDING_REFERRAL_INFO,
} from "../actions/actionTypes";
import { RecordReferralInfoErrorResponse, RecordReferralInfoResponse } from "src/types/referralInfo";

const initialState = {
  creating: false,
};

type ReferralAction = UnknownAction;

export function ReferralReducer(state = initialState, action: ReferralAction) {
  switch (action.type) {
    case RECORDING_REFERRAL_INFO:
      return {
        ...state,
        creating: true,
      };

    case RECORDING_REFERRAL_INFO_SUCCEEDED: {
      const result = action.payload as RecordReferralInfoResponse;
      return {
        ...state,
        creating: false,
        item: result,
        errors: null,
      };
    }

    case RECORDING_REFERRAL_INFO_FAILED: {
      const error = action.payload as RecordReferralInfoErrorResponse;
      return {
        ...state,
        creating: false,
        errors: error,
      };
    }

    default:
      return state;
  }
}
